import appConstants from "../../../../../appConstants";
import {
  MultiSelectFilter,
  StaticFilter,
  DateTimeFilter,
} from "../../../../dataGrid/columnFilters";
import { formatDateYear } from "../../../../dataGrid/gridUtilities";
import CommandCellRenderer from "../../../../dataGrid/cellRenderer/CommandCellRenderer";

export default class GridConfig {
  constructor(configuration) {
    const config = configuration || {};
    this.name = "GridConfiguration";
    this.config = GridConfig.getConfiguration(config);
  }

  static getConfiguration() {
    return GridConfig.getDefaultConfiguration();
  }

  static getCommandCellRenderer = (params) => {
    const commandConfig = {
      editCommand: "editHoliday",
      editTitle: "Edit Holiday",
      deleteCommand: "deleteHoliday",
      deleteTitle: "Delete Holiday",
    };
    return (
      <CommandCellRenderer
        commandConfig={commandConfig}
        params={{ ...params }}
      />
    );
  };

  static getTerminalFilterOptions = (params) => {
    return params.context.terminalList;
  };

  static getStateFilterOptions = (params) => {
    return params.context.stateList;
  };

  static getCountryFilterOptions = (params) => {
    return params.context.countryList;
  };

  static getDefaultConfiguration() {
    return {
      title: appConstants.gridNames.TerminalAcces,
      keyColumn: "holidayId",
      rowSelection: "single",
      defaultColDef: {
        sortable: true,
        filter: true,
        resizable: true,
        filterFramework: MultiSelectFilter,
      },
      columns: [
        {
          headerName: "holidayId",
          field: "holidayId",
          hide: true,
          headerTooltip: "holiday Id",
        },
        {
          headerName: "Holiday Date",
          headerTooltip: "Holiday Date",
          field: "holidayDate",
          filterFramework: DateTimeFilter,
          valueFormatter: (params) => formatDateYear(params),
          filterParams: {
            DATETYPE: appConstants.DATETYPES.DATEYEAR,
          },
          minWidth: appConstants.columnWidth.W_140,
        },
        {
          headerName: "Weekday",
          headerTooltip: "Weekday",
          field: "dow",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_120,
        },
        {
          headerName: "Holiday Name",
          headerTooltip: "Holiday Name",
          field: "holidayName",
          filterFramework: MultiSelectFilter,
          minWidth: appConstants.columnWidth.W_150,
        },
        {
          headerName: "Terminal",
          headerTooltip: "Terminal",
          valueGetter: (params) => {
            return params.data.terminalApplicable || [];
          },
          minWidth: appConstants.columnWidth.W_120,
          filterFramework: StaticFilter,
          filterParams: {
            getStaticOptions: GridConfig.getTerminalFilterOptions,
          },
        },
        {
          headerName: "State",
          headerTooltip: "State",
          valueGetter: (params) => {
            return params.data.stateApplicable || [];
          },
          filterFramework: StaticFilter,
          filterParams: {
            getStaticOptions: GridConfig.getStateFilterOptions,
          },
          minWidth: appConstants.columnWidth.W_120,
        },
        {
          headerName: "Country",
          headerTooltip: "Country",
          valueGetter: (params) => {
            return params.data.countryApplicable || [];
          },
          filterFramework: StaticFilter,
          filterParams: {
            getStaticOptions: GridConfig.getCountryFilterOptions,
          },
          minWidth: appConstants.columnWidth.W_120,
        },

        {
          headerName: "Commands",
          headerTooltip: "Commands",
          field: "command",
          cellRendererFramework: GridConfig.getCommandCellRenderer,
          minWidth: appConstants.columnWidth.TERMINAL_COMMANDS,
          maxWidth: appConstants.columnWidth.TERMINAL_COMMANDS,
          filter: false,
          filterFramework: null,
          sortable: false,
        },
      ],
    };
  }
}
